import React, { useEffect, useState } from "react";
import { getEvents } from "../Service/Api"; 
import Slider from "react-slick"; 
const HomeEvent = () => {
    const [data, setData] = useState([]);

    useEffect(() => {
        const getData = async () => {
            const datas = await getEvents();
            setData(datas);
        };
        getData();
    }, []);
    var settings = {
        autoplay: true,
        infinite: true,
        autoplaySpeed: 2000,
        speed: 1000,
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: false,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    };
    return (
        <>
            <div className="row">
                <div className="eventbg">
                    <Slider {...settings}>
                        {/* {data.length > 0 && data.map((item, index) => (
      <div className="item">
                         <div className="canvas_blk">
                              <div className="canvas_blkimg">
                                <LazyLoad> <img src={`https://webapi.entab.info/api/image/${item.images}`} className="img-fluid" alt="St. Francis Xavier School"/> </LazyLoad>
                                  
                              </div>
                              <div className="canvas_blkdesc">
                              <div className="canvas_blkbottom">
                                     <span>{item.date}</span> 
                                 </div>
                                 <div className="canvas_blktitle"><p>{item.title} </p>
                                 <p>  <span>   <LazyLoad><img src="https://webapi.entab.info/api/image/SFXH/public/images/location.png" className="img-fluid" alt="St. Francis Xavier School"/></LazyLoad> {item.venue}</span></p>
                                 </div>
                               
                              </div>
                          </div>
                    </div>
                     ))} */}
                         <div className="item">
                            <div className="canvas_blk">
                                <div className="canvas_blkimg">
                                    <img src="https://webapi.entab.info/api/image/SFXH/public/images/canvas1.png" className="img-fluid" alt="St. Francis Xavier School" />

                                </div>
                                <div className="canvas_blkdesc">
                                    <div className="canvas_blktitle"><p>Art Activity</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="item">
                            <div className="canvas_blk">
                                <div className="canvas_blkimg">
                                    <img src="https://webapi.entab.info/api/image/SFXH/public/images/canvas2.png" className="img-fluid" alt="St. Francis Xavier School" />

                                </div>
                                <div className="canvas_blkdesc">
                                    <div className="canvas_blktitle"><p>Art Activity</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </Slider>
                    {/* <button className="button">
                        <Link to="/events">
                            Read More</Link>
                    </button> */}
                </div>
            </div>
        </>
    )
}

export default HomeEvent